import {graphQLClient} from 'src/services/shared/GraphQLService';
import {gql} from "graphql-request";

const updateConnectionMutation = gql`
  mutation UpdateConnection(
    $client_id: uuid
    $req: AddConnectionRequest!
  ) {
    update_connection(client_id: $client_id, req: $req) {
      saas
    }
  }
`;

export const updateConnection = async (
  parameters: any
) => {
  const {
    hasuraAccessToken,
    client_id,
    saas,
    connectionId,
    ...fieldValues
  } = parameters

  const saasIdentifier = saas.identifier;

  if (!saasIdentifier) throw new Error('saas required');
  if (!connectionId) throw new Error('connectionId required');

  const client = await graphQLClient({accessToken: hasuraAccessToken});

  const variables = {
    client_id: client_id,
    req: {
      saas: saasIdentifier,
      connection_id: connectionId,
      ...fieldValues
    }
  };

  const result = await client.request(
    updateConnectionMutation,
    variables
  )

  if (result.error) throw new Error(result.error.message);

  return result;
}
